import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { AddressDetailsSearchResults } from '../../Models/Domains/Address/AddressDetailsSearchResults';

declare var IS_RUNNING_IN_APP_POOL;

export class RetrieveAddressDetailsClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(id: string): Promise<AddressDetailsSearchResults, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Address/RetrieveAddressDetails/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { id: id }

    return AjaxWrapper.get<AddressDetailsSearchResults, any>(url, data);
  }
}

